import type { OwaDate } from 'owa-datetime';
import type { OwaDateRange } from '../OwaDateRange';
import getDatesOnEndPartChanged from './getDatesOnEndPartChanged';

/**
 * This function returns new start and end time based the change of the end time zone
 * It updates the end time to match the existing time in the newly selected time zone
 */
export default function getDatesOnEndTimeZoneChanged(
    prevStartDate: OwaDate,
    prevEndDate: OwaDate,
    newTimeZone: string
): OwaDateRange {
    if (prevStartDate && prevEndDate && newTimeZone) {
        return getDatesOnEndPartChanged(prevStartDate, newTimeZone, prevEndDate, prevEndDate);
    }
    return null;
}
